/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ContentType } from "./http-client";
export class Agents {
  http;
  constructor(http) {
    this.http = http;
  }
  /**
   * @description Stream an interactive LLM chat session. Adapts dynamically to authenticated staff vs public guest.
   *
   * @tags Agents
   * @name Chat
   * @summary Adaptive Interactive Agent Chat Stream
   * @request POST:/api/agents/chat
   * @secure
   */
  chat = (data, params = {}) =>
    this.http.request({
      path: `/api/agents/chat`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Submit a complex prompt for durable background agent execution via Temporal.
   *
   * @tags Agents
   * @name CreateAgentTask
   * @summary Create Agent Task
   * @request POST:/api/agents/tasks
   * @secure
   */
  createAgentTask = (data, params = {}) =>
    this.http.request({
      path: `/api/agents/tasks`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve status and generated proposal for an agent task.
   *
   * @tags Agents
   * @name GetAgentTask
   * @summary Get Agent Task
   * @request GET:/api/agents/tasks/{task_id}
   * @secure
   */
  getAgentTask = (taskId, params = {}) =>
    this.http.request({
      path: `/api/agents/tasks/${taskId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Submit human supervisor approval or rejection signal for a paused agent workflow.
   *
   * @tags Agents
   * @name ApproveAgentTask
   * @summary Approve Agent Task
   * @request POST:/api/agents/tasks/{task_id}/approve
   * @secure
   */
  approveAgentTask = (taskId, data, params = {}) =>
    this.http.request({
      path: `/api/agents/tasks/${taskId}/approve`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Query per-organization LLM token usage and cost ledger entries.
   *
   * @tags Agents
   * @name GetUsageLedger
   * @summary Get Usage Ledger
   * @request GET:/api/agents/usage/ledger
   * @secure
   */
  getUsageLedger = (query, params = {}) =>
    this.http.request({
      path: `/api/agents/usage/ledger`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve aggregated LLM token usage and estimated cost summary for organization.
   *
   * @tags Agents
   * @name GetUsageSummary
   * @summary Get Usage Summary
   * @request GET:/api/agents/usage
   * @secure
   */
  getUsageSummary = (query, params = {}) =>
    this.http.request({
      path: `/api/agents/usage`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve aggregated LLM token usage and estimated cost summary for organization.
   *
   * @tags Agents
   * @name GetUsageSummary2
   * @summary Get Usage Summary
   * @request GET:/api/agents/usage/summary
   * @originalName getUsageSummary
   * @duplicate
   * @secure
   */
  getUsageSummary2 = (query, params = {}) =>
    this.http.request({
      path: `/api/agents/usage/summary`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
}
